export function computeInputHint(input: string, firstOptionName: string | null, controlActivated: boolean): string {
  if (!controlActivated || input === '' || !firstOptionName) {
    return '';
  }

  const startsWithInput = firstOptionName.toLowerCase().startsWith(input.toLowerCase());

  if (startsWithInput && input.length < firstOptionName.length) {
    return firstOptionName.slice(input.length);
  }

  return '';
}
